// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"style_disclaimer__OdABL","details":"style_details__I_aOT","col":"style_col__YvCuO","images":"style_images__5xnlT","img":"style_img__uVxCg"};